import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import { inputStyles } from '../TextField/styles';

const SelectStyled = styled.select`
  ${inputStyles}
  ${({ theme, customTheme }) => {
    if (customTheme === 'leads') {
      return css`
        background-color: rgba(255, 255, 255, 0.1);
        color: ${theme.colors.neutral.white};
        border:1px solid ${theme.colors.neutral.white};
        border-radius: ${rem(2)};
        height: ${rem(55)};
        font-weight:300;
        letter-spacing:${rem(1)};
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        ::placeholder {
          color: ${theme.colors.neutral.gray95};
        }
        :-ms-expand {
          display: none;
        }
        :-ms-clear {
          display: none;
        }
        /** cross-brower fallback to change the BG color of the select dropdowns */
        /**  This affects IE, Edge, and Firefox */
        option {
          background-color: #265e8a;
        }
    `;
    }
    return false;
  }
}
`;

export default SelectStyled;
